module.exports = __webpack_public_path__ + "img/background-organization@2x.87b40ad1.jpg";